import { jsx as e } from "react/jsx-runtime";
import { forwardRef as n } from "react";
import d from "styled-components";
import m from "../IconButton/IconButton.js";
const p = d(m).withConfig({
  displayName: "StyledIconButton"
})([
  "&&{box-shadow:",
  ";}"
], ({ theme: o }) => `0 2px 8px 0 ${o.secondaryShadow}`), s = /* @__PURE__ */ n(({ size: o = "superExtraLarge", variant: t = "contained", ...r }, a) => /* @__PURE__ */ e(p, {
  ...r,
  size: o,
  variant: t,
  ref: a
}));
s.displayName = "Fab";
export {
  s as default
};
